import { Title } from "./ArticleSubHead.styled";

export const ArticleSubHead = ({ title, addStyles }) => (
  <Title addStyles={addStyles}>{title}</Title>
);
